import "../collections/providers.js";
import "../collections/slots.js";
import "./provider.js";
import "./slot.js";
import "./base.js";

// Used to store the state of the reselection widget

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.Reselector = class Reselector extends (
  AppointmentBooking.SlotSuggester.Models.Base
) {
  defaults() {
    return {
      variant: "outlined-elevated", // The variant of the reselector
      showMessage: true, // Whether or not to show the context message above the selector
      bookingPhoneNumber: null, // The phone number for booking help
      desiredSlotConditions: {}, // The conditions that we want satisfied by matching slots
      desiredStartTime: null, // The desired start time as inferred from the desiredSlotConditions
      desiredDepartmentId: null, // The desired department as inferred from the desiredSlotConditions
      selectedDate: null, // Date of suggested slots the user is currently viewing
      selectedProviderOption: null, // Which of 'desired' or 'pool' provider option did the user choose
      selectedSlotId: null, // The id of the slot the user ultimately chooses to book
      availableProviders: [],
      matchingSlots: [],
      suggestedSlots: [],
    };
  }
};

AppointmentBooking.SlotSuggester.Models.Reselector.prototype.relations = [
  {
    // All Providers referenced in the desired or pool
    type: Backbone.HasMany,
    key: "availableProviders",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Provider",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Providers",
  },
  {
    // Slots that match the given search criteria
    type: Backbone.HasMany,
    key: "matchingSlots",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
  },
  {
    // Slots suggested for the currently selected date
    type: Backbone.HasMany,
    key: "suggestedSlots",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
  },

  {
    // The desired provider as inferred from the desiredSlotConditions
    type: Backbone.HasOne,
    key: "desiredProvider",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Provider",
  },
  {
    // Slots that match the given search criteria
    type: Backbone.HasMany,
    key: "desiredProviderSlots",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
  },

  {
    // Providers who are in the pool of available slots
    type: Backbone.HasMany,
    key: "poolProviders",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Provider",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Providers",
  },
  {
    // Slots on providers who are in the pool
    type: Backbone.HasMany,
    key: "poolSlots",
    relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
    collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
  },
];
